import React, { useState } from "react";
import {
    Box,
    Button,
    Grid,
    Typography,
    Paper,
    InputBase,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import { Add, DescriptionOutlined } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AddCustomerDialog from "./NewCustomer";
import EditCustomerDialog from "./EditCustomer";
// import CustomDataTable from "./CustomDataTable";
// CustomDataTable
import { useFetchCustomersQuery, useDeleteCustomerMutation, useBlacklistCustomerMutation } from "../../store/services/customerService";
import CustomDataTable from "../../components/DataTable";
import { IMAGE_URL } from "../../store/services/constants";
import colors from "../../styles/colors";
import Loader from "../../components/Loader";
import ActionMenu from "../../components/ActionMenu";
import { Icons } from "../../assets/Svgs";
import { toast } from "react-toastify";
import CustomSwitch from "../../components/Switch.component";

const Customers = () => {
    const theme = useTheme();
    const words = useSelector((state) => state.authReducer.words);
    const navigate = useNavigate();

    const [search, setSearch] = useState("");
    const [open, setOpen] = useState(false);
    const [focusedTab, setFocusedTab] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [editModal, setEditModal] = useState(false);
    const [selectedCustomer, setSelecetedCustomer] = useState({});

    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteCustomerId, setDeleteCustomerId] = useState(null);


    const [deleteCustomer, { isLoading: isDeleting }] = useDeleteCustomerMutation();
    const [blacklistCustomer, { isLoading: isBlacklisting }] = useBlacklistCustomerMutation();
    const { data, isLoading, error } = useFetchCustomersQuery({ page_no: currentPage });


    const filteredData = data?.data?.data.filter((customer) =>
        customer.name?.toLowerCase().includes(search.toLowerCase()) ||
        customer.email?.toLowerCase().includes(search.toLowerCase()) ||
        customer.phone?.includes(search)
    );

    const handleDeleteCustomer = async () => {
        if (!deleteCustomerId) return;
        try {
            await deleteCustomer(deleteCustomerId).unwrap();
            toast.success("Customer deleted successfully!");
            setDeleteModal(false); // Close the dialog
        } catch (error) {
            toast.error("Failed to delete customer. Please try again.");
            console.error(error);
        }
    };

    const handleBlacklistToggle = async (customerId) => {
        try {
            const response = await blacklistCustomer(customerId).unwrap();
            if (response.status == 1) {
                toast.success('User status changed successfully', {
                    autoClose: 1000
                });
            }
            else {
                toast.error(error.error, {

                });
            }

        } catch (error) {
            toast.error(error.error)
            console.error("Failed to update blacklist status:", error);
        }
    };




    const columns = [
        {
            field: "image",
            label: "Image",
            render: (value) => (
                <img
                    src={IMAGE_URL + value || "/default-profile.png"}
                    alt="Customer"
                    style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                />
            ),
        },
        // { field: "username", label: "Customer" },

        {
            field: 'username',
            label: 'Customer',
            render: (value, record) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', }} >
                    <Typography sx={{ fontFamily: 'PBo', fontSize: 13, color: colors.text }}>
                        {record.username}
                    </Typography>
                    <Typography sx={{ fontFamily: 'PMe', fontSize: 11, ml: 2, color: colors.textPrimary }}>
                        ID: {record.id}
                    </Typography>
                </Box>
            ),
        },
        { field: "email", label: "Email" },

        {
            field: "ads_count",
            label: "Ads count",
            render: (value, record) => (
                <Box
                    sx={{
                        backgroundColor: colors.primaryLight,
                        //  : "#4CAF50",
                        color: "#fff",
                        padding: "7px 8px",
                        borderRadius: "4px",
                        textAlign: "center",
                        fontFamily: "PMe",
                        fontSize: 12,
                        maxWidth: 60,
                    }}
                >
                    {value}
                </Box>
            ),
        },
        {
            field: "bookings_count",
            label: "Bookings count",
            render: (value, record) => (
                <Box
                    sx={{
                        backgroundColor: "#4CAF50",
                        color: "#fff",
                        padding: "7px 8px",
                        maxWidth: 60,
                        borderRadius: "4px",
                        textAlign: "center",
                        fontFamily: "PMe",
                        fontSize: 12
                    }}
                >
                    {value}
                </Box>
            ),
        },

        {
            field: "status",
            label: "Status",
            render: (value, record) => (
                <CustomSwitch
                    onChange={() => handleBlacklistToggle(record.id)}
                    checked={value}
                />
            ),
        },

        {
            field: "created_at",
            label: "Created At",
            render: (value) => new Date(value).toLocaleDateString(),
        },


        // {
        //     field: "Action",
        //     label: "Action",
        //     render: (value, record) => (
        //         <ActionMenu
        //             onAction={(action) => {
        //                 if (action === "edit") {
        //                     setSelecetedCustomer(record);
        //                     setEditModal(true);
        //                 } else if (action === "delete") {
        //                     setDeleteCustomerId(record.id); // Set the selected customer ID
        //                     setDeleteModal(true); // Open delete confirmation dialog
        //                 }
        //             }}
        //             menuItems={[
        //                 { label: "View", action: "view" },
        //                 { label: "Edit", action: "edit" },
        //                 { label: "Delete", action: "delete" },
        //             ]}
        //         />
        //     ),
        // }
    ];

    return (
        <>
            <Box sx={{ padding: "16px", backgroundColor: "#F5F5F5" }}>
                <Loader open={isLoading || isBlacklisting} />
                <Grid container spacing={1} alignItems="center">
                    {/* Tabs */}
                    <Grid item xs={12} sm={6} md={5} lg={4}>
                        <Box
                            sx={{
                                backgroundColor: "#fff",
                                p: 1,
                                borderRadius: "10px",
                                display: "flex",
                                flexDirection: "row",
                            }}
                        >
                            <Box onClick={() => setFocusedTab(1)} sx={{ cursor: "pointer" }}>
                                <Typography
                                    sx={{
                                        fontFamily: "PMe",
                                        fontSize: 13,
                                        color: focusedTab === 1 ? "#000" : "#999",
                                    }}
                                >
                                    {words["All Customers"]}
                                </Typography>
                                {focusedTab === 1 && (
                                    <Box
                                        sx={{
                                            width: "100%",
                                            height: 3,
                                            backgroundColor: colors.primary,
                                            mt: 1,
                                            borderRadius: 5,
                                        }}
                                    />
                                )}
                            </Box>
                        </Box>
                    </Grid>

                    {/* Search Bar */}
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <Paper
                            component="form"
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                borderRadius: "10px",
                                boxShadow: "none",
                                padding: "0.3rem",
                            }}
                        >
                            <Box sx={{ width: 2, borderRadius: 5, height: 20, backgroundColor: colors.primary, ml: 2 }} />
                            <InputBase
                                onChange={(e) => setSearch(e.target.value)} // Update search state
                                value={search} // Controlled input
                                sx={{ ml: 2, flex: 1, fontSize: 13, fontFamily: "PMe" }}
                                placeholder="Search Here"
                                inputProps={{ "aria-label": "search here" }}
                            />
                            <IconButton aria-label="search">
                                <Icons.searchIcon color={colors.primary} />
                            </IconButton>
                        </Paper>
                    </Grid>

                    {/* Action Buttons */}
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                        <Box sx={{ display: "flex", gap: "10px", flexDirection: "row" }}>
                            <Button
                                variant="outlined"
                                startIcon={<DescriptionOutlined sx={{ color: colors.primary }} />}
                                sx={{
                                    borderRadius: "20px",
                                    fontSize: 12,
                                    padding: "8px 16px",
                                    borderColor: colors.primary,
                                    color: "#000",
                                    fontFamily: "PMe",
                                    textTransform: "none",
                                }}
                            >
                                {words["Generate Report"]}
                            </Button>
                            <Button
                                onClick={() => setOpen(true)}
                                variant="contained"
                                startIcon={<Add />}
                                sx={{
                                    backgroundColor: colors.primary,
                                    fontSize: 12,
                                    color: "white",
                                    fontFamily: "PMe",
                                    borderRadius: "20px",
                                    padding: "8px 16px",
                                    textTransform: "none",
                                }}
                            >
                                {words["New customer"]}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/* Data Table */}
            <Box sx={{ paddingRight: '16px', paddingLeft: '16px', backgroundColor: colors.bg }}>
                {isLoading ? (
                    <Typography></Typography>
                ) : error ? (
                    <Typography>Error loading customers</Typography>
                ) : (
                    <CustomDataTable
                        data={filteredData || []} // Use filtered data
                        columns={columns}
                        totalPages={data?.data?.last_page || 1}
                        currentPage={currentPage}
                        onPageChange={(page) => setCurrentPage(page)}

                    />
                )}
            </Box>

            <AddCustomerDialog open={open} onClose={() => setOpen(false)} />
            <EditCustomerDialog data={selectedCustomer} open={editModal} onClose={() => setEditModal(false)} />

            <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
                <DialogTitle
                    sx={{ fontFamily: 'PSBo' }}
                >Are you sure?</DialogTitle>
                <DialogContent>
                    <Typography
                        sx={{ fontFamily: 'PRe' }}
                    >
                        Are you sure you want to delete this customer? Deleting a customer will remove all their data.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setDeleteModal(false)}
                        variant="outlined"
                        sx={{
                            borderRadius: "20px",
                            fontSize: 12,
                            textTransform: "none",
                            fontFamily: "PMe",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDeleteCustomer}
                        variant="contained"
                        disabled={isDeleting}

                        sx={{
                            backgroundColor: colors.danger,
                            fontSize: 12,
                            color: "white",
                            borderRadius: "20px",
                            padding: "8px 16px",
                            textTransform: "none",
                            fontFamily: "PMe",
                        }}
                    >
                        {isDeleting ? "Deleting..." : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>



        </>
    );
};

export default Customers;
